module.exports = __webpack_public_path__ + "082d860315be9e7ad32fcdb29678a1f7.svg";